/**
 * Creates an item in the database
 */
export function createItem(type, key, forcedValue, opts = {}) {
  if (!type || !key) {
    this.error('Type or key is not defined for create operation')
    this.call('openNotification', {
      type: 'error',
      title: this.call('polyglot', 'editor.crud.projectIdRequired.title'),
      message: this.call('polyglot', 'editor.crud.projectIdRequired.message')
    })
    return
  }

  type = this.getPlural(type)

  const item =
    this.call('isObject', forcedValue) && forcedValue.value
      ? forcedValue
      : this.call('getDefaultValuePerType', type, key)

  if (this.call('hasArtboard', type) || this.call('hasExecutable', type)) {
    const canvasPageChanges = this.call('returnAddedCanvasPageChanges', type, key)
    if (canvasPageChanges) {
      opts.append = canvasPageChanges
    }
  }

  const res = this.sdk.addItem(type, item, opts)

  this.testAll(`Creating ${key} in ${type}`, () => [
    this.testCase(
      'Item exists in root state',
      'exists',
      this.getSchemaItem(key, type) && this.getDataItem(key, type)
    )
  ])

  return res
}

/**
 * Appends created item in sidebar
 */
export async function createItemInSidebar(type, key) {
  const section = this.call('findFileSidebarSection', type)
  const List = section?.FilesSidebarList?.content

  if (!section || !List) {
    return this.error(`Section for type "${type}" not found in sidebar`)
  }

  await section.FilesSidebarList.content.append(
    {
      extends: 'FilesSidebarListItem',
      state: {
        key,
        type
      }
    },
    `${List.__ref.__children.length}`
  )
}

/**
 * Creates artboard in Canvas
 */
export async function createArtboardInCanvas(type, key, opts) {
  if (!this.isCanvas()) {
    return this.error('Creating artboard on canvas requires active canvas page')
  }

  await this.call('createCanvasArtboard', type, key, opts)

  this.testAll(`Creating ${key} ${type} artboard in Canvas`, () => [
    this.testCase('Item exists on canvas', 'exists', this.call('findComponentOnCanvas', key)),
    this.testCase(
      'Item was create in canvas page',
      'existsIf',
      this.getActiveCanvasPage() !== 'Default',
      this.call('inOnCurrentCanvasPage', type, key)
    )
  ])
}

/**
 * Appends created item in Canvas
 */
export function createItemInCanvas(type, key) {
  if (!this.isCanvas()) {
    this.warn('Creating on canvas requires active canvas page')
  }

  const Collection = this.getCanvasCollection()
  if (!Collection) {
    return this.error('Canvas Collection was not found')
  }

  const frameWindow = this.getCanvasFrameWindow()
  const value = this.getDataItem(key, type)
  const newType = this.call('toTitleCase', typeof value)

  if (this.call('hasArtboard', type)) {
    if (!new frameWindow[newType](value)) debugger
    Collection.context[type][key] = new frameWindow[newType](value)
  } else if (this.call('hasExecutable', type)) {
    if (!value) debugger
    Collection.context[type][key] = value
  }
}

export function createItemInChosen(type, key) {
  if (!this.isCanvas()) {
    this.warn('Creating on canvas requires active canvas page')
  }

  const chosen = this.getChosenKey()
  if (chosen) {
    const frameWindow = this.getCanvasFrameWindow()
    const value = this.getDataItem(key, type)
    const newType = this.call('toTitleCase', typeof value)
    const chosenContext = this.getChosenElementContext()

    if (this.call('hasArtboard', type)) {
      chosenContext[type][key] = new frameWindow[newType](value)
    } else if (this.call('hasExecutable', type)) {
      chosenContext[type][key] = value
    }
  }
}

export async function createCanvasItem(type, key, opts) {
  if (!this.isCanvas()) {
    return this.error('Creating on canvas requires active canvas page')
  }

  if (!type || !key) {
    return this.error('Type or key is not defined for create operation')
  }

  type = this.getPlural(type)

  await this.call('createItemInCanvas', type, key)
  await this.call('createItemInChosen', type, key)

  const testArr = []

  const testFn = async () => {
    testArr.push(
      this.testCase('Item exists in canvas context', 'exists', this.getCanvasContext()[type][key]),
      this.testCase(
        'Item exists in choosen context',
        'existsIf',
        this.getChosenKey(),
        this.getChosenKey() && this.getChosenElementContext()[type][key]
      )
    )

    if (!opts.skipSidebar) {
      await this.call('createItemInSidebar', type, key)
      testArr.push(
        this.testCase(
          'Item exists in sidebar',
          'existsIf',
          this.call('isTypeSidebarActive', type),
          this.call('findFileSidebarItem', type, key)
        )
      )
    }
    return testArr
  }

  this.testAll(`Creating ${key} ${type}`, testFn)

  if (this.call('hasArtboard', type)) {
    await this.call('createArtboardInCanvas', type, key, opts)
  }
}

export async function createMultipleItems(items, opts = {}) {
  try {
    items.forEach((item) => {
      const elementExisted = this.getSchemaItem(item.key, item.type)
      console.log(elementExisted)

      if (elementExisted) {
        this.call('updateItem', item.type, item.key, item)
      } else {
        this.call('createItem', item.type, item.key, item)
      }
    })
  } catch (error) {
    throw new Error(`Failed to create item: ${error.message}`)
  }
}
